/*
  "Make an offer" dialog of the product page (snippets/noma-make-offer.liquid).
  1. The button opens the dialog; Close, Escape and a click outside close it.
  2. On Send: the amount must be a plain dollar amount, at least the minimum (store rule) and below the price (at or above the
     price the buyer should simply buy). Name and e-mail are checked by the browser (required fields).
  3. The offer is posted to the offers service (data-endpoint) as JSON in a text/plain body (a "simple" cross-site request, so
     the browser sends it at once without an extra CORS check first). The service answers { ok: true } or { error: "..." } in
     words meant for the buyer; it checks everything again against the live item. The first offer after a quiet spell can take
     a few seconds (the service wakes up), so the button says "Sending..." until the answer comes.
  4. Success: the form is replaced by the thank-you text. Failure: the reason is shown above the form, nothing is lost.
  WHY a window capture listener + stopImmediatePropagation: no other script on the page (theme, apps, Shopify's captcha, which
  once submitted a refused contact form by itself, 2026-10-07) may act on this form's submit.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-noma-offer]');
  if (!root) return;
  var dialog = root.querySelector('dialog');
  var form = root.querySelector('[data-noma-offer-form]');
  var done = root.querySelector('[data-noma-offer-done]');
  if (!dialog || !form) return;

  var endpoint = root.getAttribute('data-endpoint');
  var minCents = parseInt(root.getAttribute('data-min'), 10) || 0;
  var priceCents = parseInt(root.getAttribute('data-price'), 10) || 0;
  var phone = root.getAttribute('data-phone') || '';
  var amount = form.querySelector('[data-noma-offer-amount]');
  var msg = form.querySelector('[data-noma-offer-amount-msg]');
  var alertBox = form.querySelector('[data-noma-offer-error]');
  var submit = form.querySelector('[data-noma-offer-submit]');
  var sending = false;

  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /* "$1,234.5" -> 123450; null when it is not a plain positive amount with at most 2 decimals */
  function cents(text) {
    var s = String(text || '').replace(/[$,\s]/g, '');
    if (!/^\d{1,7}(\.\d{1,2})?$/.test(s)) return null;
    var parts = s.split('.');
    return parseInt(parts[0], 10) * 100 + parseInt(((parts[1] || '') + '00').slice(0, 2), 10);
  }

  function value(name) {
    var el = form.querySelector('[name="' + name + '"]');
    return el ? el.value.trim() : '';
  }

  function open() {
    if (dialog.open) return;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    var first = (done && !done.hidden) ? done.querySelector('[data-noma-offer-close]') : amount;
    if (first) first.focus();
  }

  function close() {
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }

  function sayAmount(text) {
    if (!msg) return;
    msg.textContent = text || '';
    msg.hidden = !text;
    if (amount) amount.setAttribute('aria-invalid', text ? 'true' : 'false');
  }

  function sayError(text) {
    if (!alertBox) return;
    alertBox.textContent = '';
    alertBox.hidden = !text;
    if (!text) return;
    var p = document.createElement('p');
    p.textContent = text;
    alertBox.appendChild(p);
    alertBox.scrollIntoView({ block: 'nearest' });
  }

  function busy(on) {
    sending = on;
    if (!submit) return;
    if (on) {
      submit.setAttribute('aria-disabled', 'true');
      submit.textContent = 'Sending...';
    } else {
      submit.removeAttribute('aria-disabled');
      submit.textContent = 'Send offer';
    }
  }

  function failed(text) {
    busy(false);
    sayError(text || ('Sorry, your offer could not be sent right now. Please try again in a minute' + (phone ? ', or call or text us at ' + phone + '.' : '.')));
  }

  root.querySelector('[data-noma-offer-open]').addEventListener('click', open);
  Array.prototype.forEach.call(dialog.querySelectorAll('[data-noma-offer-close]'), function (b) {
    b.addEventListener('click', close);
  });
  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) close(); /* click on the backdrop */
  });
  if (amount) amount.addEventListener('input', function () { sayAmount(''); });

  window.addEventListener('submit', function (e) {
    if (e.target !== form) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (sending) return; /* second press while the first is on its way */
    sayError('');
    var c = cents(amount && amount.value);
    var problem = '';
    if (c === null || c <= 0) problem = 'Enter your offer as a dollar amount, for example 150 or 150.50.';
    else if (c < minCents) problem = 'The lowest offer we accept is ' + money(minCents) + '.';
    else if (c >= priceCents) problem = 'Your offer is not below the price (' + money(priceCents) + '). You can simply buy the part.';
    if (problem) {
      sayAmount(problem);
      amount.focus();
      return;
    }
    sayAmount(''); /* a good amount: clear the note of an earlier refused one */
    amount.value = (c / 100).toFixed(2);
    var body = {
      product: root.getAttribute('data-product'),
      variant: root.getAttribute('data-variant'),
      offer: (c / 100).toFixed(2),
      listed: (priceCents / 100).toFixed(2),
      name: value('name'),
      email: value('email'),
      phone: value('phone'),
      message: value('message'),
      website: value('website')
    };
    busy(true);
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 30000);
    fetch(endpoint, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: { 'content-type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify(body),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        clearTimeout(timer);
        if (r.ok && j.ok) {
          busy(false);
          form.hidden = true;
          if (done) {
            done.hidden = false;
            var b = done.querySelector('[data-noma-offer-close]');
            if (b) b.focus();
          }
          return;
        }
        failed(j.error);
      });
    }, function () {
      clearTimeout(timer);
      failed('');
    });
  }, true);
})();
